// TankView shared formatters. See TSP-142.
// Sourced from NeedsActionPage (fmt*, 0-decimal currency to match existing UI)
// and ChartRenderer (convertToFormalHours, HH:MM:SS).

export function fmt$(val) {
  if (val === null || val === undefined || isNaN(val)) return "$0";
  return "$" + Number(val).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function fmtNum(val) {
  if (val === null || val === undefined || isNaN(val)) return "0";
  return Number(val).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function fmtDec(val, places = 2) {
  if (val === null || val === undefined || isNaN(val)) return Number(0).toFixed(places);
  return Number(val).toLocaleString("en-US", { minimumFractionDigits: places, maximumFractionDigits: places });
}

// Seconds to HH:MM. Negative values are preserved with a leading minus.
export function fmtTime(s) {
  if (!s || isNaN(s)) return "00:00";
  const neg = s < 0;
  if (neg) s = Math.abs(s);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = (h < 10 ? "0" + h : h) + ":" + (m < 10 ? "0" + m : m);
  return neg ? "-" + r : r;
}

// Seconds to HH:MM:SS (sub-second seconds rounded to 2 decimals).
// Imported from ChartRenderer where chart tooltips need the seconds component.
export function convertToFormalHours(totalSeconds) {
  const negative = totalSeconds < 0;
  if (negative) totalSeconds = totalSeconds * -1;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds - hours * 3600) / 60);
  let seconds = totalSeconds - hours * 3600 - minutes * 60;
  seconds = Math.round(seconds * 100) / 100;
  let result = hours < 10 ? "0" + hours : hours;
  result += ":" + (minutes < 10 ? "0" + minutes : minutes);
  result += ":" + (seconds < 10 ? "0" + seconds : seconds);
  return negative ? "-" + result : result;
}

export function formatBytes(n) {
  if (n == null) return "";
  if (n < 1024) return n + " B";
  if (n < 1024 * 1024) return (n / 1024).toFixed(0) + " KB";
  return (n / (1024 * 1024)).toFixed(1) + " MB";
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch (_) {
    return String(iso);
  }
}
